const actions = {
  async listAdditionalFeeRequest(context, payload) {
    try {
      const response = await this.$api.call(
        "finops_additional_fee_request.list",
        payload,
      );
      if (response.data === null) {
        response.data = [];
      }
      const responseData = response.data;

      if (typeof payload.tab !== "undefined" && payload.tab !== null) {
        context.commit("mutationAdditionalFeeRequestList", {
          responseData,
          tab: payload.tab,
        });
      } else {
        context.commit("mutationAdditionalFeeRequestList", responseData);
      }

      context.commit("mutationAdditionalFeeRequestMeta", response.meta);

      return response;
    } catch (error) {
      context.commit("mutationAdditionalFeeRequestList", []);
      context.commit("mutationAdditionalFeeRequestMeta", {});

      throw error;
    }
  },
};

export default actions;
